// Modified from: https://github.com/ueberdosis/tiptap/blob/main/packages/extension-link/src/helpers/autolink.ts
// This is needed because the default behaviour aggressively unlinks items while typing,
// producing weird behaviour
//
// Modifications from the original:
// 1. No longer removes links at all
// 2. Only adds link after typing a space at the end
import {
	combineTransactionSteps,
	getChangedRanges,
	getMarksBetween,
} from '@tiptap/core';
import { MarkType } from 'prosemirror-model';
import { Plugin, PluginKey } from 'prosemirror-state';
import { getLinkId } from './util';

type LinkidOptions = {
	type: MarkType;
}

export function linkids(options: LinkidOptions): Plugin {
	return new Plugin({
		key: new PluginKey('trLinkIds'),
		appendTransaction: (transactions, oldState, newState) => {
			const docChanges = transactions.some((transaction) => transaction.docChanged)
				&& !oldState.doc.eq(newState.doc);

			if (!docChanges) {
				return null;
			}

			const transform = combineTransactionSteps(oldState.doc, [...transactions]);
			if (!transform.steps.length) {
				return null;
			}
			const changes = getChangedRanges(transform);
			const { tr } = newState;

			changes.forEach(({ newRange }) => {
				getMarksBetween(newRange.from, newRange.to, newState.doc)
					.filter((item) => item.mark.type === options.type)
					.filter(({ mark }) => !mark?.attrs.id)
					.forEach(({ from, to, mark }) => {
						tr.removeMark(from, to, options.type);
						tr.addMark(from, to, options.type.create({
							href: mark?.attrs.href,
							id: getLinkId(),
						}));
					});
			});

			if (!tr.steps.length) {
				return null;
			}

			return tr;
		},
	});
}
